import { CommonModule } from '@angular/common';
import {
  Component,
  computed,
  EventEmitter,
  Input,
  Output,
  Signal,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { EventTemplateVisual } from '@models/design-templates/event-template-visual.model';
import { EventAttendeeTicketOrder } from '@models/events/event-attendee-ticket-order.model';
import { Event } from '@models/events/event.model';
import { User } from '@models/users/user.model';
import { OrderOverviewComponent } from '@modules/events/components/event-payment/components/order-overview/order-overview.component';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { AuthService } from '@services/auth/auth.service';
import { ScreenWidthService } from '@services/shared/screen-width.service';
import { DateUtils } from '@utils/date-utils';

@Component({
  selector: 'app-generic-ticket-info-success',
  standalone: true,
  imports: [CommonModule, TranslateModule, OrderOverviewComponent],
  templateUrl: './generic-ticket-info-success.component.html',
  styleUrl: './generic-ticket-info-success.component.scss',
})
export class GenericTicketInfoSuccessComponent {
  private _ticketOrder?: EventAttendeeTicketOrder;
  isDesktop?: boolean;
  @Input() mainImage?: string;
  loggedUser?: User;
  myOrders?: EventAttendeeTicketOrder[];
  @Output() openTickets = new EventEmitter<string>();

  @Input() set ticketOrder(ticketOrder: EventAttendeeTicketOrder | undefined) {
    if (ticketOrder) {
      this._ticketOrder = ticketOrder;
    }
  }

  get ticketOrder(): EventAttendeeTicketOrder | undefined {
    return this._ticketOrder;
  }

  @Input() event?: Event;
  @Output() onClose = new EventEmitter();
  currentLang?: string;

  encodedMainImage: Signal<string> = computed(() => {
    return this.event ? this.event.getEncodedMainImage() : '';
  });

  constructor(
    private translateService: TranslateService,
    private screenWidthService: ScreenWidthService,
    private authService: AuthService,
  ) {
    this.screenWidthService
      .isDesktop()
      .pipe(takeUntilDestroyed())
      .subscribe({
        next: (isDesktop: boolean) => {
          this.isDesktop = isDesktop;
        },
      });

    this.translateService.onLangChange
      .pipe(takeUntilDestroyed())
      .subscribe(() => {
        this.currentLang = this.translateService.currentLang;
      });
    this.currentLang = this.translateService.currentLang;

    this.authService.userSubject
      .pipe(takeUntilDestroyed())
      .subscribe((user) => (this.loggedUser = user));
  }

  seeTicket() {
    this.openTickets.emit('user');
  }

  seeAllTickets() {
    this.openTickets.emit('allTickets');
  }

  seeAllOrders() {
    this.openTickets.emit('allOrders');
  }

  get visual(): EventTemplateVisual | undefined {
    return this.event?.eventTemplate?.visual;
  }

  protected readonly DateUtils = DateUtils;
}
